import React, { useState, useRef, memo } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { useDayPickerStyles } from './styles'
import { useOutsideClick } from '~/core/utils/hooks'
import { useI18n } from '~/core/i18n'

const DayPicker = ({ value, disabled, isDayDisabled, placeholder, onChange, ...props }) => {
  const [msg] = useI18n()
  const [active, setActive] = useState(false)
  const classes = useDayPickerStyles()
  const dayPickerRef = useRef()

  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day =>
    msg(`common.days.${day}`)
  )

  useOutsideClick(dayPickerRef, () => setActive(false), active)

  const handleDaySelect = dayIndex => {
    setActive(false)
    onChange(dayIndex + 1)
  }

  return (
    <article
      ref={dayPickerRef}
      className={classnames(classes.dayPicker, {
        [classes.disabled]: disabled
      })}
      {...props}
    >
      <div
        className={classnames(classes.daySlider, {
          [classes.daySliderActive]: active
        })}
      >
        {days.map((day, dayIndex) => {
          const dayDisabled = isDayDisabled && isDayDisabled(dayIndex + 1)
          return (
            <span
              key={day}
              className={classnames({
                [classes.disabled]: dayDisabled,
                [classes.dayActive]: value === dayIndex + 1
              })}
              onClick={() => handleDaySelect(dayIndex)}
            >
              {day.slice(0, 2)}
            </span>
          )
        })}
      </div>
      <div className={classes.dayValue} onClick={() => setActive(true)}>
        {value ? days[value - 1] : placeholder}
      </div>
    </article>
  )
}

DayPicker.propTypes = {
  disabled: PropTypes.bool,
  isDayDisabled: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7]),
  onChange: PropTypes.func
}

DayPicker.defaultProps = {
  onChange: () => {},
  placeholder: 'Select day'
}

export default memo(DayPicker)
